// 📅 기간 필터 공용 유틸
// OrdersPage의 isInSelectedDateRange와 동일한 규칙 (DATE_RANGE_OPTIONS 기준)

/**
 * 주어진 날짜가 선택된 기간 범위에 포함되는지 판별
 * @param date 검사할 날짜
 * @param dateRange '전체' | '최근 7일' | '이번 달' | '사용자 지정'
 * @param startDate 사용자 지정 시작일
 * @param endDate 사용자 지정 종료일 (그날 23:59:59까지 포함)
 */
export function isDateInRange(
  date: Date,
  dateRange: string,
  startDate: Date | null,
  endDate: Date | null,
): boolean {
  const now = new Date();

  if (dateRange === '전체') return true;

  if (dateRange === '최근 7일') {
    const sevenDaysAgo = new Date(now);
    sevenDaysAgo.setDate(now.getDate() - 7);
    return date >= sevenDaysAgo;
  }

  if (dateRange === '이번 달') {
    return (
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth()
    );
  }

  if (dateRange === '사용자 지정') {
    if (!startDate || !endDate) return true;
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    return date >= start && date <= end;
  }

  return true;
}
